import { jsx } from 'react/jsx-runtime';

const ArrowLeft = ({ width = 24, height = 24, fill = "#000", className }) => {
  return /* @__PURE__ */ jsx("span", { className, children: /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 24 24",
      fill: "none",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.1973 5.73913C10.4902 5.44638 10.965 5.44629 11.2578 5.73913C11.5505 6.03199 11.5505 6.50682 11.2578 6.79968L6.80957 11.2469H19C19.4142 11.2469 19.75 11.5827 19.75 11.9969C19.7499 12.411 19.4141 12.7469 19 12.7469H6.81152L11.2578 17.1932C11.5507 17.4861 11.5507 17.9619 11.2578 18.2548C10.965 18.5474 10.4901 18.5472 10.1973 18.2548L4.46973 12.5272C4.42101 12.4785 4.38309 12.4232 4.35059 12.3661C4.33511 12.3389 4.31869 12.3122 4.30664 12.2831C4.28592 12.2328 4.27104 12.1807 4.26172 12.1278C4.25422 12.0853 4.25001 12.0416 4.25 11.9969C4.25 11.9517 4.25404 11.9072 4.26172 11.8641C4.27082 11.8133 4.28506 11.7631 4.30469 11.7147L4.30859 11.7049C4.32936 11.6558 4.35546 11.6094 4.38574 11.5663C4.41034 11.5313 4.43844 11.498 4.46973 11.4667L10.1973 5.73913Z",
          fill
        }
      )
    }
  ) });
};

export { ArrowLeft };
